import { createFileRoute } from "@tanstack/react-router";

import { BLUESKY_TIMING_FAQS } from "@/components/marketing/bluesky-timing-faqs";
import { BlueskyTimingTool } from "@/components/marketing/bluesky-timing-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so it must not reach into the component module —
 * that would drag the whole tool into the shared entry chunk. The FAQs live in
 * their own module for exactly this reason; see `bluesky-timing-faqs.ts`.
 */
export const Route = createFileRoute("/(public)/tools/bluesky-best-time")({
  head: () => toolPageHead("blueskyBestTime", BLUESKY_TIMING_FAQS),
  component: BlueskyTimingTool,
});
